export default `<!-- Start of core script-->
<script>
window.sparkOptions = {
  siteId: "#SITE_ID#",#DOMAIN#
  platform: null,
};
</script>
<script async src="#SPARKJS_URL#"></script>
<!-- required for linking to order or quotes: https://docs.sparklayer.io/my-account-interface#yT5mS -->
<script async src="https://cdn.sparklayer.io/spark-redirect.js"></script>
<!-- End of core script-->`;
